import {useContext} from 'react';
import {AuthContext} from '../providers/AuthProvider'

export default function useContexto() {
    return useContext(AuthContext);
};